import { createFileRoute } from "@tanstack/react-router";
import SpravatoTransferCare from "@/pages/SpravatoTransferCare";
export const Route = createFileRoute("/spravato-transfer-care")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Transfer Your SPRAVATO® Care | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Transfer SPRAVATO® treatment to Neuro Wellness in Coral Springs, FL. Continue esketamine therapy with our team. Free consultation and insurance verification.",
        },
        {
          property: "og:title",
          content: "Transfer Your SPRAVATO® Care | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Transfer SPRAVATO® treatment to Neuro Wellness in Coral Springs, FL. Continue esketamine therapy with our team. Free consultation and insurance verification.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-transfer-care",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-transfer-care",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoTransferCare />;
}
